// Imports
import React from 'react';
import styled from 'styled-components/macro';
import sanitizeHTML from '../../../../../../shareables/front-end/utils/sanitize-html/sanitize-html';
import { StyledEditorGeneratedContentContainer } from '../../page-types/shared-components/styled-editor-generated-content-container';


// Styled components
const Container = styled.div`
	line-height: 1.3125rem;
	margin-bottom: 1.3rem;
	overflow-x: auto;
`;

const Content = styled(StyledEditorGeneratedContentContainer)`
	width: 100%;
	overflow-wrap: anywhere;
	
	p:last-child {
		margin-bottom: 0;
	}
`;


// Define the accepted props
interface Props {
	children: string;
}


// Function component
const LeadingText: React.FC<Props> = ({ children }) => (
	<Container>
		<Content
			dangerouslySetInnerHTML={{
				__html: sanitizeHTML(children, { extendAllowedTags: ['iframe'] }),
			}}
		/>
	</Container>
);

export default LeadingText;
